import React from 'react';
import PropTypes from 'prop-types';

import Tooltip from 'components/Tooltip';
import styles from './styles.module.scss';

const StyledContendHint = ({ id, text, imageSrc }) => (
	<Tooltip id={id} float={false} noArrow events={['click']} offset={4}>
		<div className={styles.HintTooltip}>
			{imageSrc ? (
				<img
					alt=""
					src={imageSrc}
					className={styles.HintTooltip_Image}
					loading="lazy"
				/>
			) : null}
			<span className={styles.HintTooltip_Content}>{text}</span>
		</div>
	</Tooltip>
);

StyledContendHint.propTypes = {
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	text: PropTypes.string.isRequired,
	imageSrc: PropTypes.string
};

export default StyledContendHint;
